"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));
var _react = _interopRequireWildcard(require("react"));
var _reactDom = require("react-dom");
var _CheckoutIntent = _interopRequireDefault(require("./CheckoutIntent.js"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// Infrastructure imports
// const wixFullstoryLoader = require('wix-fullstory-loader');
// wixFullstoryLoader({label: 'artstore-checkout-index'});
var Main = /*#__PURE__*/function (_Component) {
  function Main() {
    return _Component.apply(this, arguments) || this;
  }
  (0, _inheritsLoose2["default"])(Main, _Component);
  var _proto = Main.prototype;
  _proto.render = function render() {
    return /*#__PURE__*/_react["default"].createElement(_CheckoutIntent["default"], null);
  };
  return Main;
}(_react.Component);
(0, _reactDom.render)(/*#__PURE__*/_react["default"].createElement(Main, null), document.getElementById('content'));